export const INITIAL_VALUE = {
  email: ''
};

export const DESCRIPTOR = {
  email: { type: 'email', required: true, message: 'Email is required' }
};
